import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
} from "@mui/material";

const getColumnWidth = (columnName, data) => {
  // Check if column contains mostly numbers
  const isNumericColumn = data?.length > 0 &&
    data.every(row => !isNaN(row[columnName]) || row[columnName] === 'N/A');

  return isNumericColumn ? '80px' : 'auto';
};

const StyledTable = styled(Table)(({ theme }) => ({
  tableLayout: "auto", // Changed from "fixed" to "auto"
  "& .MuiTableCell-head": {
    backgroundColor: theme.palette.secondary.light,
    fontWeight: "bold",
    padding: "12px 16px",
    textTransform: "uppercase",
    color: theme.palette.text.primary,
    borderBottom: `2px solid ${theme.palette.divider}`,
  },
  "& .MuiTableCell-root": {
    padding: "12px 16px",
    borderBottom: `1px solid ${theme.palette.divider}`,
    wordWrap: "break-word",
  },
  "& .MuiTableRow-root:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

/**
 * Plain table for the dashboard cards.
 *
 * @param {Object} props
 * @param {Object[]} props.data
 * @param {string[]} props.columns Row keys to show, in order.
 * @param {(row: Object) => void} [props.onRowClick] When given, rows become
 *   clickable (task lists open the task this way).
 */
const ListComponent = ({ data, columns, onRowClick }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{ mb: 2, borderRadius: 2, overflow: "hidden" }}
    >
      <StyledTable>
        <TableHead>
          <TableRow>
            {columns?.map((column, index) => (
              <TableCell
                key={index}
                sx={{ width: getColumnWidth(column, data) }}
              >
                {column}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.length ? (
            data.map((row, rowIndex) => (
              <TableRow
                key={row.id ?? rowIndex}
                hover={Boolean(onRowClick)}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
                sx={onRowClick ? { cursor: "pointer" } : undefined}
              >
                {columns?.map((column, colIndex) => (
                  <TableCell
                    key={colIndex}
                    sx={{ width: getColumnWidth(column, data) }}
                  >
                    {row[column] || "N/A"}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell
                colSpan={columns.length}
                sx={{ textAlign: "center", padding: "20px" }}
              >
                No Data Available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </StyledTable>
    </TableContainer>
  );
};

export default ListComponent;
